import {LocalNotificationData} from './LocalNotificationData';

export default (_: StringDictionary): _ is LocalNotificationData =>
  _.hasOwnProperty('designator') &&
  Reflect.get(_, 'designator') === 'local-notification-data' &&
  _.hasOwnProperty('context');

export type StringDictionary = {[key: string]: string | object | number};
